import script from "./worksDetailPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./worksDetailPhone.vue?vue&type=script&setup=true&lang=js"

import "./worksDetailPhone.vue?vue&type=style&index=0&id=263feb41&lang=less&scoped=true"

import exportComponent from "D:\\code\\saicDesign_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-263feb41"]])

export default __exports__